import type { LocationDropdownItem } from './updateOrder';

export const STATES: LocationDropdownItem[] = [
  {
    en: 'Alabama',
    twoLetterCode: 'AL',
    fr: 'Alabama',
    es: 'Alabama',
    de: 'Alabama',
    nl: 'Alabama',
    zh: '阿拉巴马',
  },
  {
    en: 'Alaska',
    twoLetterCode: 'AK',
    fr: 'Alaska',
    es: 'Alaska',
    de: 'Alaska',
    nl: 'Alaska',
    zh: '阿拉斯加',
  },
  {
    en: 'Arizona',
    twoLetterCode: 'AZ',
    fr: 'Arizona',
    es: 'Arizona',
    de: 'Arizona',
    nl: 'Arizona',
    zh: '亚利桑那',
  },
  {
    en: 'Arkansas',
    twoLetterCode: 'AR',
    fr: 'Arkansas',
    es: 'Arkansas',
    de: 'Arkansas',
    nl: 'Arkansas',
    zh: '阿肯色',
  },
  {
    en: 'California',
    twoLetterCode: 'CA',
    fr: 'Californie',
    es: 'California',
    de: 'Kalifornien',
    nl: 'Californië',
    zh: '加利福尼亚',
  },
  {
    en: 'Colorado',
    twoLetterCode: 'CO',
    fr: 'Colorado',
    es: 'Colorado',
    de: 'Colorado',
    nl: 'Colorado',
    zh: '科罗拉多',
  },
  {
    en: 'Connecticut',
    twoLetterCode: 'CT',
    fr: 'Connecticut',
    es: 'Connecticut',
    de: 'Connecticut',
    nl: 'Connecticut',
    zh: '康涅狄格',
  },
  {
    en: 'Delaware',
    twoLetterCode: 'DE',
    fr: 'Delaware',
    es: 'Delaware',
    de: 'Delaware',
    nl: 'Delaware',
    zh: '特拉华',
  },
  {
    en: 'Florida',
    twoLetterCode: 'FL',
    fr: 'Floride',
    es: 'Florida',
    de: 'Florida',
    nl: 'Florida',
    zh: '佛罗里达',
  },
  {
    en: 'Georgia',
    twoLetterCode: 'GA',
    fr: 'Géorgie',
    es: 'Georgia',
    de: 'Georgien',
    nl: 'Georgia',
    zh: '格鲁吉亚',
  },
  {
    en: 'Hawaii',
    twoLetterCode: 'HI',
    fr: 'Hawaï',
    es: 'Hawái',
    de: 'Hawaii',
    nl: 'Hawaii',
    zh: '夏威夷',
  },
  {
    en: 'Idaho',
    twoLetterCode: 'ID',
    fr: 'Idaho',
    es: 'Idaho',
    de: 'Idaho',
    nl: 'Idaho',
    zh: '爱达荷',
  },
  {
    en: 'Illinois',
    twoLetterCode: 'IL',
    fr: 'Illinois',
    es: 'Illinois',
    de: 'Illinois',
    nl: 'Illinois',
    zh: '伊利诺斯',
  },
  {
    en: 'Indiana',
    twoLetterCode: 'IN',
    fr: 'Indiana',
    es: 'Indiana',
    de: 'Indiana',
    nl: 'Indiana',
    zh: '印第安纳',
  },
  {
    en: 'Iowa',
    twoLetterCode: 'IA',
    fr: 'Iowa',
    es: 'Iowa',
    de: 'Iowa',
    nl: 'Iowa',
    zh: '爱荷华',
  },
  {
    en: 'Kansas',
    twoLetterCode: 'KS',
    fr: 'Kansas',
    es: 'Kansas',
    de: 'Kansas',
    nl: 'Kansas',
    zh: '堪萨斯',
  },
  {
    en: 'Kentucky',
    twoLetterCode: 'KY',
    fr: 'Kentucky',
    es: 'Kentucky',
    de: 'Kentucky',
    nl: 'Kentucky',
    zh: '肯塔基',
  },
  {
    en: 'Louisiana',
    twoLetterCode: 'LA',
    fr: 'Louisiane',
    es: 'Luisiana',
    de: 'Louisiana',
    nl: 'Louisiana',
    zh: '路易斯安那',
  },
  {
    en: 'Maine',
    twoLetterCode: 'ME',
    fr: 'Maine',
    es: 'Maine',
    de: 'Maine',
    nl: 'Maine',
    zh: '缅因',
  },
  {
    en: 'Maryland',
    twoLetterCode: 'MD',
    fr: 'Maryland',
    es: 'Maryland',
    de: 'Maryland',
    nl: 'Maryland',
    zh: '马里兰',
  },
  {
    en: 'Massachusetts',
    twoLetterCode: 'MA',
    fr: 'Massachusetts',
    es: 'Massachusetts',
    de: 'Massachusetts',
    nl: 'Massachusetts',
    zh: '马萨诸塞',
  },
  {
    en: 'Michigan',
    twoLetterCode: 'MI',
    fr: 'Michigan',
    es: 'Michigan',
    de: 'Michigan',
    nl: 'Michigan',
    zh: '密歇根',
  },
  {
    en: 'Minnesota',
    twoLetterCode: 'MN',
    fr: 'Minnesota',
    es: 'Minnesota',
    de: 'Minnesota',
    nl: 'Minnesota',
    zh: '明尼苏达',
  },
  {
    en: 'Mississippi',
    twoLetterCode: 'MS',
    fr: 'Mississippi',
    es: 'Mississippi',
    de: 'Mississippi',
    nl: 'Mississippi',
    zh: '密西西比',
  },
  {
    en: 'Missouri',
    twoLetterCode: 'MO',
    fr: 'Missouri',
    es: 'Misuri',
    de: 'Missouri',
    nl: 'Missouri',
    zh: '密苏里',
  },
  {
    en: 'Montana',
    twoLetterCode: 'MT',
    fr: 'Montana',
    es: 'Montana',
    de: 'Montana',
    nl: 'Montana',
    zh: '蒙大拿',
  },
  {
    en: 'Nebraska',
    twoLetterCode: 'NE',
    fr: 'Nebraska',
    es: 'Nebraska',
    de: 'Nebraska',
    nl: 'Nebraska',
    zh: '内布拉斯加',
  },
  {
    en: 'Nevada',
    twoLetterCode: 'NV',
    fr: 'Nevada',
    es: 'Nevada',
    de: 'Nevada',
    nl: 'Nevada',
    zh: '内华达',
  },
  {
    en: 'New Hampshire',
    twoLetterCode: 'NH',
    fr: 'New Hampshire',
    es: 'New Hampshire',
    de: 'New Hampshire',
    nl: 'New Hampshire',
    zh: '新罕布什尔',
  },
  {
    en: 'New Jersey',
    twoLetterCode: 'NJ',
    fr: 'New Jersey',
    es: 'Nueva Jersey',
    de: 'New Jersey',
    nl: 'New Jersey',
    zh: '新泽西',
  },
  {
    en: 'New Mexico',
    twoLetterCode: 'NM',
    fr: 'Nouveau-Mexique',
    es: 'Nuevo México',
    de: 'New Mexico',
    nl: 'New Mexico',
    zh: '新墨西哥',
  },
  {
    en: 'New York',
    twoLetterCode: 'NY',
    fr: 'New York',
    es: 'Nueva York',
    de: 'New York',
    nl: 'New York',
    zh: '纽约',
  },
  {
    en: 'North Carolina',
    twoLetterCode: 'NC',
    fr: 'Caroline du Nord',
    es: 'Carolina del Norte',
    de: 'North Carolina',
    nl: 'North Carolina',
    zh: '北卡罗莱纳',
  },
  {
    en: 'North Dakota',
    twoLetterCode: 'ND',
    fr: 'Dakota du Nord',
    es: 'Dakota del Norte',
    de: 'North Dakota',
    nl: 'North Dakota',
    zh: '北达科他',
  },
  {
    en: 'Ohio',
    twoLetterCode: 'OH',
    fr: 'Ohio',
    es: 'Ohio',
    de: 'Ohio',
    nl: 'Ohio',
    zh: '俄亥俄',
  },
  {
    en: 'Oklahoma',
    twoLetterCode: 'OK',
    fr: 'Oklahoma',
    es: 'Oklahoma',
    de: 'Oklahoma',
    nl: 'Oklahoma',
    zh: '奥克拉荷马',
  },
  {
    en: 'Oregon',
    twoLetterCode: 'OR',
    fr: 'Oregon',
    es: 'Oregón',
    de: 'Oregon',
    nl: 'Oregon',
    zh: '俄勒冈',
  },
  {
    en: 'Pennsylvania',
    twoLetterCode: 'PA',
    fr: 'Pennsylvanie',
    es: 'Pensilvania',
    de: 'Pennsylvania',
    nl: 'Pennsylvania',
    zh: '宾夕法尼亚',
  },
  {
    en: 'Rhode Island',
    twoLetterCode: 'RI',
    fr: 'Rhode Island',
    es: 'Rhode Island',
    de: 'Rhode Island',
    nl: 'Rhode Island',
    zh: '罗德岛',
  },
  {
    en: 'South Carolina',
    twoLetterCode: 'SC',
    fr: 'Caroline du Sud',
    es: 'Carolina del Sur',
    de: 'South Carolina',
    nl: 'South Carolina',
    zh: '南卡罗莱纳',
  },
  {
    en: 'South Dakota',
    twoLetterCode: 'SD',
    fr: 'Dakota du Sud',
    es: 'Dakota del Sur',
    de: 'South Dakota',
    nl: 'South Dakota',
    zh: '南达科他',
  },
  {
    en: 'Tennessee',
    twoLetterCode: 'TN',
    fr: 'Tennessee',
    es: 'Tennessee',
    de: 'Tennessee',
    nl: 'Tennessee',
    zh: '田纳西',
  },
  {
    en: 'Texas',
    twoLetterCode: 'TX',
    fr: 'Texas',
    es: 'Texas',
    de: 'Texas',
    nl: 'Texas',
    zh: '德克萨斯',
  },
  {
    en: 'Utah',
    twoLetterCode: 'UT',
    fr: 'Utah',
    es: 'Utah',
    de: 'Utah',
    nl: 'Utah',
    zh: '犹他',
  },
  {
    en: 'Vermont',
    twoLetterCode: 'VT',
    fr: 'Vermont',
    es: 'Vermont',
    de: 'Vermont',
    nl: 'Vermont',
    zh: '佛蒙特',
  },
  {
    en: 'Virginia',
    twoLetterCode: 'VA',
    fr: 'Virginie',
    es: 'Virginia',
    de: 'Virginia',
    nl: 'Virginia',
    zh: '弗吉尼亚',
  },
  {
    en: 'Washington',
    twoLetterCode: 'WA',
    fr: 'Washington',
    es: 'Washington',
    de: 'Washington',
    nl: 'Washington',
    zh: '华盛顿',
  },
  {
    en: 'Washington DC',
    twoLetterCode: 'DC',
    fr: 'Washington DC',
    es: 'Washington DC',
    de: 'Washington, D.C',
    nl: 'Washington DC',
    zh: '华盛顿特区',
  },
  {
    en: 'West Virginia',
    twoLetterCode: 'WV',
    fr: 'Virginie-Occidentale',
    es: 'Virginia Occidental',
    de: 'West Virginia',
    nl: 'West Virginia',
    zh: '西弗吉尼亚',
  },
  {
    en: 'Wisconsin',
    twoLetterCode: 'WI',
    fr: 'Wisconsin',
    es: 'Wisconsin',
    de: 'Wisconsin',
    nl: 'Wisconsin',
    zh: '威斯康辛',
  },
  {
    en: 'Wyoming',
    twoLetterCode: 'WY',
    fr: 'Wyoming',
    es: 'Wyoming',
    de: 'Wyoming',
    nl: 'Wyoming',
    zh: '怀俄明',
  },
];
